"use client";

import { I } from "@/components/kamibot-v2/discord";

export function PremiumHero() {
  const handleSeePlans = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById("plans");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="prem-hero">
      <div className="shell">
        <div className="prem-hero-grid">
          <div className="prem-hero-text">
            <span className="section-eyebrow">
              <I.heart /> SUPPORT · 멤버십
            </span>
            <h1 className="prem-hero-title">
              <span className="gowun shy">받기 미안한 마음으로</span>
              <br />
              만든 페이지예요.
            </h1>
            <div className="prem-hero-letter gowun">
              <p>
                카미봇은 가능한 한 많은 분들께 무료로 열어두고 싶어요.
                그래서 이 페이지를 어떻게 써야 할지 한참 고민했어요.
              </p>
              <p>
                <b>프리미엄은 &ldquo;더 좋은 카미봇&rdquo;이 아니에요.</b>
                <br />
                대부분의 기능은 그대로 무료고, 여기 잠겨 있는 건
                <em> 실제로 사용할 때마다 비싼 기능들</em>과
                <em> 카미봇이 직접 표현하고 싶은 작은 감사들</em>이에요.
              </p>
              <p className="shy">
                그래도 응원해주실 수 있다면, 정말 감사할 거예요.
                혹시 어렵다면 — <b>괜찮아요.</b> 카미봇은 무료로도 계속 잘 작동할 거예요.
              </p>
            </div>

            <div className="prem-hero-actions">
              <a
                className="btn btn-primary"
                href="#plans"
                onClick={handleSeePlans}
              >
                <I.heart /> 플랜 보기
              </a>
            </div>

            <div className="prem-hero-meta">
              <span><I.check /> 14일 환불 보장</span>
              <span className="dot" />
              <span><I.check /> 언제든 해지 가능</span>
              <span className="dot" />
              <span><I.check /> 무료 기능은 그대로</span>
            </div>
          </div>

          <div className="prem-hero-mascot">
            <div className="mascot-frame mascot-frame-extended">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src="/kamibot-character/kamibot-extended.png" alt="" />
            </div>
            <div className="mascot-bub gowun">
              미리 감사드려요…
              <span className="bub-tail" />
            </div>
            <div className="mascot-deco">
              <span className="deco-sparkle s1">✦</span>
              <span className="deco-sparkle s2">✧</span>
              <span className="deco-sparkle s3">✦</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
